import styled from 'styled-components';

export const StyledFrame = styled.div`
  background: var(--bundle-border-color);
  padding: 2px;
  border-radius: 8px;
  min-width: 300px;
  max-width: 400px;
  min-height: 158px;
  width: 100%;

  .price-container {
    width: 100%;
    position: relative;

    .price {
      margin: 10px 0 4px 0;
      border: 1px solid #000;
      height: auto;
      width: auto;
      padding: 5px 10px 7px 10px;
      border-radius: 6px;
      box-shadow: inset 0 -2px 0 0 rgba(0, 115, 0, 1);

      .totalPrice {
        text-shadow: 0 -1px 0.2px #338908, 0 1px 0.2px #338908,
          -1px 0 0.2px #338908, 1px 0 0.2px #338908, 1px 1px 0.2px #338908,
          -1px -1px 0.2px #338908, -1px 1px 0.2px #338908,
          1px -1px 0.2px #338908;
        align-items: center;
        max-height: 19px;
      }
    }
  }
` as any;

export const StyledSpecialOffer = styled.div`
  height: 158px;
  width: 100%;
  box-sizing: border-box;
  font-family: var(--font-family), Arial;

  .frame {
    height: 100%;
    width: 100%;
    min-height: 158px;
    position: relative;
    background: ${(props: any) =>
      props.backgroundImage ? `url(${props.backgroundImage})` : ''};
    background-size: cover;
    background-position: center;
    padding: 6px;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    .products__container {
      width: 100%;
      height: 100%;
    }
  }
` as any;

export const ProductsBackground = styled.div`
  height: 100px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
` as any;
